"use client";
import React, { useEffect, useState } from "react";
import "./landing-v6.css";
import { Nav, Marquee } from "./ui";
import {
  Hero,
  CorePillars,
  Features,
  Quotes,
  MoreFeatures,
  Pricing,
  FAQ,
  Footer,
} from "./blocks";
import { CharacterConstellation, WaxSealCTA } from "./wow";

function ThemeToggle({ theme, setTheme }) {
  return (
    <div
      className="qv6-theme-toggle"
      style={{
        position: "fixed",
        right: 20,
        bottom: 20,
        zIndex: 100,
        background: "color-mix(in oklab, var(--paper-3) 88%, transparent)",
        border: "1px solid var(--rule)",
        borderRadius: 999,
        padding: 4,
        display: "inline-flex",
        gap: 2,
        backdropFilter: "blur(12px)",
        boxShadow: "0 12px 30px -12px rgba(0,0,0,0.35)",
        fontFamily: "'JetBrains Mono', monospace",
      }}
    >
      {[
        { key: "paper", label: "paper" },
        { key: "midnight", label: "midnight" },
      ].map((t) => {
        const on = theme === t.key;
        return (
          <button
            key={t.key}
            onClick={() => setTheme(t.key)}
            aria-pressed={on}
            style={{
              all: "unset",
              cursor: "pointer",
              padding: "7px 14px",
              borderRadius: 999,
              fontSize: 10,
              textTransform: "uppercase",
              letterSpacing: "0.14em",
              color: on ? (t.key === "midnight" ? "#0B0B20" : "#fff") : "var(--muted)",
              background: on ? "var(--pink)" : "transparent",
              fontWeight: on ? 600 : 500,
              transition: "background 0.2s, color 0.2s",
            }}
          >
            {t.label}
          </button>
        );
      })}
    </div>
  );
}

export default function LandingV6() {
  const [theme, setTheme] = useState("paper");

  useEffect(() => {
    try {
      const saved = typeof window !== "undefined" && window.localStorage.getItem("qv6-theme");
      if (saved === "paper" || saved === "midnight") setTheme(saved);
    } catch (_) {}
  }, []);

  useEffect(() => {
    try {
      window.localStorage.setItem("qv6-theme", theme);
    } catch (_) {}
  }, [theme]);

  return (
    <div className={`qv6 ${theme === "midnight" ? "theme-midnight" : ""}`}>
      <Nav />
      <Hero />
      <CorePillars />
      <Marquee
        items={[
          "fiction",
          "screenplays",
          "worldbuilding",
          "memoir",
          "revision",
          "dialogue",
          "drafting",
          "a second opinion",
          "a third one too",
        ]}
      />
      <Features />
      <CharacterConstellation />
      <Quotes />
      <MoreFeatures />
      <Pricing />
      <FAQ />
      <WaxSealCTA />
      <Footer />
      <ThemeToggle theme={theme} setTheme={setTheme} />
    </div>
  );
}
